import React from 'react';

import { registerEmail } from '../entities/session';
import useContent from '../hooks/useContent';
import OtpPage from './OtpPage';

const RegistrationOtpPage = () => {
    const content = useContent();
    const email = registerEmail.use();

    return (
        <OtpPage
            id={'registration-otp-page'}
            title={content('forms.otp.header.title')}
            confirmation={content(
                'forms.otp.header.confirmation',
                '{email}',
                (match, i) => {
                    return (
                        <span key={i}>
                            <br />
                            <strong>{email}</strong>
                        </span>
                    );
                }
            )}
            instruction={content('forms.otp.header.instruction')}
            mode={'register'}
        />
    );
};

export default RegistrationOtpPage;
